export default __webpack_public_path__ + "static/media/high-resolution-designs.1d22bd72.svg";